import { render } from "./LoaderData.vue?vue&type=template&id=6b8a89a3"
import script from "./LoaderData.vue?vue&type=script&lang=js"
export * from "./LoaderData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__